import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/Card";

interface CountRow {
  label: string;
  count: number;
}

interface DemographicsData {
  totalClients: number;
  byGender: CountRow[];
  byRace: CountRow[];
  byAgeRange: CountRow[];
  byEducation: CountRow[];
  byHousing: CountRow[];
  byIncomeBracket: CountRow[];
  byMaritalStatus: CountRow[];
  byAbuseType: CountRow[];
  byVictimType: CountRow[];
}

interface DemographicsReportProps {
  data: DemographicsData;
}

function StatSection({ title, items, total }: { title: string; items: CountRow[]; total: number }) {
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-sm font-medium">{title}</CardTitle>
      </CardHeader>
      <CardContent className="p-0">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b bg-muted/50">
              <th className="px-4 py-2 text-left font-medium text-muted-foreground">Category</th>
              <th className="px-4 py-2 text-right font-medium text-muted-foreground">Count</th>
              <th className="px-4 py-2 text-right font-medium text-muted-foreground">%</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.label} className="border-b last:border-0 hover:bg-muted/30">
                <td className="px-4 py-2">{item.label}</td>
                <td className="px-4 py-2 text-right font-mono">{item.count}</td>
                <td className="px-4 py-2 text-right font-mono text-muted-foreground">
                  {total > 0 ? ((item.count / total) * 100).toFixed(1) : 0}%
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent>
    </Card>
  );
}

export function DemographicsReport({ data }: DemographicsReportProps) {
  const total = data.totalClients;

  return (
    <div className="space-y-6">
      <div className="rounded-lg border bg-primary/5 p-4">
        <p className="text-lg font-semibold">
          Total Clients: <span className="text-primary">{total}</span>
        </p>
      </div>

      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <StatSection title="By Gender" items={data.byGender} total={total} />
        <StatSection title="By Race" items={data.byRace} total={total} />
        <StatSection title="By Age Range" items={data.byAgeRange} total={total} />
        <StatSection title="By Education" items={data.byEducation} total={total} />
        <StatSection title="By Housing" items={data.byHousing} total={total} />
        <StatSection title="By Income Bracket" items={data.byIncomeBracket} total={total} />
        <StatSection title="By Marital Status" items={data.byMaritalStatus} total={total} />
        <StatSection title="By Abuse Type" items={data.byAbuseType} total={total} />
        <StatSection title="By Victim Type" items={data.byVictimType} total={total} />
      </div>
    </div>
  );
}
